import { useCallback, useState } from "react";
import { Share2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { ShareImage, wrapLines } from "@/v2/Growth";

const W = 1080, H = 1350;
const SENSITIVE = /weigh|weight|lb|kg|pound|calor|bmi|size|inch|waist|period|cycle|meno|medic|anxi|depress/i;

async function drawWin(cv, g, month, showTitle) {
  await Promise.all(["600 100px Fraunces", "italic 400 56px Fraunces", "400 34px Figtree", "600 220px Fraunces"].map((f) => document.fonts.load(f).catch(() => null)));
  const c = cv.getContext("2d");
  c.fillStyle = "#4F6B55"; c.fillRect(0, 0, W, H);
  const glow = c.createRadialGradient(W - 120, 180, 20, W - 120, 180, 820);
  glow.addColorStop(0, "#E9C46A66"); glow.addColorStop(1, "#4F6B5500"); c.fillStyle = glow; c.fillRect(0, 0, W, H);
  c.fillStyle = "rgba(255,255,255,0.7)"; c.font = "400 34px Figtree"; c.fillText(`CAMRYN · ${month.toUpperCase()} WIN`, 90, 150);
  c.fillStyle = "#FBF9F5"; c.font = "600 220px Fraunces"; c.fillText(`${g.progress}`, 90, 470);
  c.font = "400 40px Figtree"; c.fillStyle = "rgba(255,255,255,0.8)"; c.fillText(`of ${g.target} ${g.target === 1 ? "day" : "days"}. Goal hit.`, 96, 540);
  c.fillStyle = "#FBF9F5"; c.font = "600 100px Fraunces";
  wrapLines(showTitle ? g.title : `My ${month} goal`, 16).slice(0, 4).forEach((l, i) => c.fillText(l, 90, 760 + i * 118));
  c.font = "italic 400 56px Fraunces"; c.fillStyle = "rgba(255,255,255,0.85)"; c.fillText("I said I would. I did.", 90, 1140);
  c.font = "400 34px Figtree"; c.fillStyle = "rgba(255,255,255,0.6)"; c.fillText("mycamryn.app", 90, 1240);
}

export function WinButton({ goal, month, testid, compact }) {
  const [open, setOpen] = useState(false);
  const [showTitle, setShowTitle] = useState(!SENSITIVE.test(goal.title));
  const draw = useCallback((cv) => drawWin(cv, goal, month, showTitle), [goal, month, showTitle]);
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={testid}
        className={compact ? "h-8 px-2.5 rounded-full bg-[#EDF2EE] text-[#4F6B55] text-[11px] font-semibold inline-flex items-center gap-1" : "h-10 px-4 rounded-full bg-[#4F6B55] text-white text-xs font-semibold inline-flex items-center gap-1.5"}>
        <Share2 className="h-3.5 w-3.5" />Share my win</button>
      {open && <ShareImage open={open} onOpenChange={setOpen} draw={draw} filename="camryn-win.png" title="Share your win" testid="win-share">
        <label className="flex items-center justify-between text-sm min-h-11 cursor-pointer" data-testid="win-share-title-row">Show the goal name
          <Switch checked={showTitle} onCheckedChange={setShowTitle} data-testid="win-share-title-switch" /></label>
      </ShareImage>}
    </>
  );
}
